<div
  class="modal-dialog modal-notify modal-danger modal-side modal-top-right"
  role="document"
>
  <!--Content-->
  <div class="modal-content">
    <!--Header-->
    <div class="modal-header">
      <p class="heading">Sign In Error</p>

      <button
        type="button"
        class="close"
        data-dismiss="modal"
        aria-label="Close"
        (click)="closeError()"
      >
        <span aria-hidden="true" class="white-text">&times;</span>
      </button>
    </div>

    <!--Body-->
    <div class="modal-body">
      <p>
        The information provided was either invalid or linked to an account
        without authorization.
      </p>
    </div>

    <!--Footer-->
    <div class="modal-footer justify-content-center">
      <a
        type="button"
        mdbBtn
        color="primary"
        outline="true"
        class="waves-effect"
        mdbWavesEffect
        (click)="closeError()"
        data-dismiss="modal"
        >Try Again</a
      >
    </div>
  </div>
  <!--/.Content-->
</div>
